import React from 'react';
import { Alert, Spinner } from 'hyperdb-utils';

const LoadingComponent = (Component) => (load) => {
  class Loader extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isLoading: true,
      };
    }

    componentDidMount() {
      load()
      .then((data) => this.setState({isLoading: false, data}))
      .catch((error) => this.setState({isLoading: false, error}));
    }

    render() {
      const props = this.props;
      const { isLoading, data, error } = this.state;
      if (isLoading) return (<Spinner />);
      else {
        if (error) return (<Alert type="error">{error}</Alert>);
      }
      return React.createElement(Component, {...props});
    }
  }
  return Loader;
};

export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/frontend/hyperdb/LoadingComponent.jsx